import EPGChannels from './EPGChannels';

export default EPGChannels;
export * from './EPGChannels';
